import { render, staticRenderFns } from "./desktop-filter.vue?vue&type=template&id=3cff516d&scoped=true"
import script from "./desktop-filter.vue?vue&type=script&lang=js"
export * from "./desktop-filter.vue?vue&type=script&lang=js"
import style0 from "./desktop-filter.vue?vue&type=style&index=0&id=3cff516d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cff516d",
  null
  
)

export default component.exports